var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.to && !_vm.disabled)?_c('router-link',{attrs:{"to":_vm.to,"exact":_vm.exact}},[_vm._t("default")],2):(_vm.href && !_vm.disabled)?_c('a',{attrs:{"href":_vm.href,"target":_vm.target}},[_vm._t("default")],2):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }